import { render } from "./LangStringTargetInput.vue?vue&type=template&id=2e3a9eaa"
import script from "./LangStringTargetInput.vue?vue&type=script&lang=js"
export * from "./LangStringTargetInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__